import { isNetworkError } from './networkErrorUtils';

type ChatSessionCaptureContext = {
    tags: {
        context: 'chat_session_creation';
    };
    extra: {
        chat_session_id: string | null;
    };
};

type CaptureException = (error: Error, context: ChatSessionCaptureContext) => unknown;

export function reportChatSessionCreationError(
    error: unknown,
    chatSessionId: string | null,
    captureException: CaptureException
): boolean {
    const normalizedError = error instanceof Error ? error : new Error(String(error));

    if (isNetworkError(normalizedError)) {
        return false;
    }

    captureException(normalizedError, {
        tags: { context: 'chat_session_creation' },
        extra: { chat_session_id: chatSessionId },
    });

    return true;
}
